
import Icon from '../../Partials/Icon';
import InfoWindow from  '../../Partials/infoWindow';


export default class {

    constructor(google,map,markers,services) 
    {
        this.infoWindow        = document.getElementById('infoWindow');
        this.contentInfowindow = document.getElementById('content-infowindow');

        let filters =  document.getElementsByClassName('filter-station-map');
        document.getElementById('regiones').addEventListener('change',this,false);
        document.getElementById('comunas').addEventListener('change',this,false)
        document.getElementById('search-stations').addEventListener('click',this,false);

        this.markers       = markers;
        this.filtersActive = new Array();

        this.array_lodash = require('lodash/array');
        
        for(let filter of filters)
        {
            filter.addEventListener('click',this,false);
        }

        this.google = google;
        this.map    = map;

        this.services = services;
    }
    
    handleEvent(evt)
    {
       let target = evt.target;

       let rules = new Array();

       let stations = window.stations.filter( station => station['Estado'] === 'true');

       let regiones = document.getElementById('regiones');
       let comunas  = document.getElementById('comunas');

       stations = this.filterRegiones( stations,regiones );
       stations = this.filterComunas(  stations,comunas)
    
       if( target.classList.contains('filter-station-map') )
       {
           console.log("epa");
            let filter = target.dataset.filter;
            this.toggleFilters(filter);
       }

       this.clearMarkers();

       this.applyFilter( stations );
       
       console.log( this.filtersActive );
    }

    filterRegiones( stations,target )
    {
        let stationFilter = new Array();

        if(target.value === 'all')
        {
            return stations;
        }

        let map    = this.map;
        let google = this.google;

        stations.forEach( station => {
            if( station['Region'] == target.value){
                stationFilter.push(station);
            }
        },this);

        let option = document.querySelector(`option[value="${target.value}"]`);

        let positionMap = new google.LatLng(option.dataset.lat,option.dataset.lng);

        map.setCenter(positionMap);

        return stationFilter;

    }

    filterComunas( stations,target )
    {
        let stationFilter = new Array();

        if(target.value === 'all')
        {
            return stations;
        }

        stations.forEach( station => {
            if( station['Comuna'] == target.value){
                stationFilter.push(station);
            }
        },this);


        return stationFilter;

    }

    toggleFilters(filter)
    {
        this.filtersActive = this.array_lodash.xor(this.filtersActive,[filter]);
    }

    clearMarkers()
    {
        this.markers.forEach( marker => {
            marker.setMap( null );
        });
    }

    applyFilter( stations )
    {
        let stationFilter = new Array();

        console.log(`apply filter`);
        console.log(stations);

        console.log("filtros activos");
        console.log(this.filtersActive);
        console.log(this.filtersActive.length);

        if( this.filtersActive.length == 0 )
        {
            this.renderStations( stations );
        }

        stations.forEach( station => {

            for (let index = 0; index < this.filtersActive.length; index++)
            {

                let filter = this.filtersActive[index];

                //En este primer if se resume todas las relaciones de filtraje que son  campo === true, desde la linea 61-68

                if( this.services.includes( filter ) )
                {
                    if( station[filter] === 'true')
                    {
                        stationFilter.push(station);
                        break;
                    }                
                }

                if( filter == 'Parafina' && station['Parafina'] == 'true')
                {
                    stationFilter.push(station);                
                    break;
                }

                if( filter == 'tiendaFull'  ) 
                {
                    if( station['EstadoTienda'] == 'true' && station['TipoTienda'] == 'Full' )
                    {
                        stationFilter.push(station);                
                        break;
                    }
                }


                if( filter == 'tiendaSelf' ) 
                {
                    if( station['EstadoTienda'] == 'true' && station['TipoTienda'] == 'Self' )
                    {
                            stationFilter.push(station);
                            break;                
                    }
                }

                if( filter == 'Acuocenter-Self' && station['FormatoLavado'] == 'Acuocenter – Self' )
                {
                    stationFilter.push(station);
                    break;              
                }	
        
                if( filter == 'Acuocenter-Full' && station['FormatoLavado'] == 'Acuocenter – Full' )
                {
                    stationFilter.push(station);
                    break;              
                }	
                

                //Faltan los otros filtros...
            }

        },this);

        this.renderStations( stationFilter );

        //console.log(stationFilter);
    }

    renderStations( stationsFilters )
    {
        let google = this.google;
        let map    = this.map;

        let marker;

        stationsFilters.forEach( station => {

            marker = new google.Marker({
                position : new google.LatLng( station.Latitud,station.Longitud),
                map      : map,
                icon     : '/wp-content/themes/dt-the7-child/assets/icons/marker.png',
                title    : station['NombreEstacion'],
            })

            this.markers.push(marker);

            var filterObject = this;

            google.event.addListener(marker, 'click', (function (marker) {

                let services = filterObject.determineServices(station);

                return function ()
                {                
                    filterObject.setContent( filterObject.printInfoWindow(station,services) ,filterObject.contentInfowindow );
                    filterObject.open();
                }
            })(marker));

        },this);

        

        
    }


    determineServices( station )
    {
        let services = '';

        this.services.forEach ( service => {

            if( station[service] === 'true' )
            {
                services += this.printIcon(service);
            }

        },this);

        if( station['Lubrax'] == '1' )
        {
            services += this.printIcon('Lubrax')
        }

        if( station['EstadoTienda'] == 'true' )
        {
            switch (station['TipoTienda']) {
                case 'Full':
                    services += this.printIcon('icon-tienda-full');
                    break;
            
                default:
                    services += this.printIcon('icon-tienda-self');
                    break;
            }
        }

        if( station['FormatoLavado'] == 'Acuocenter – Full' )
        {
            services += this.printIcon('new-icon-lavado');
        }	

        if( station['FormatoLavado'] == 'Acuocenter – Self' )
        {
            services += this.printIcon('autolavado-nuevo');
        }		
        
        if( station['EstadoIsla'] == 'Operando' )
        {
            switch ( station['TipoIsla'] )
            {
                case 'Full':
                    services += this.printIcon('icon-isla-full');
                    break;
                case 'Mixto':
                    services += this.printIcon('icon-isla-mixto');
                    break;            
                default:
                    services += this.printIcon('icon-isla-self');
                    break;
            }
        }

        

        return services;
    }

    printInfoWindow( station,services )
    {
        return InfoWindow.render(station,services);
    }

    printIcon( key )
    {
        return  Icon.render( key );
    }

    setContent( info,contentInfowindow )
    {
        contentInfowindow.innerHTML = info;
    }

    open()
    {
        this.infoWindow.style.display = 'block';
    }


    
}
